import {
  computed,
  toRef,
} from "vue";

import PuxTablePlugin from "../plugin/PuxTablePlugin";

import {
  cloneDeep,
  forEach,
} from "lodash-es";

export default function RowActionsAPI(props, {
  urlParametersLocal = computed(() => ({})),
}) {
  const rowActions = toRef(props, "rowActions");

  const {
    checkPermissionsSync,
  } = PuxTablePlugin.PermissionAPI();

  const rowActionsFiltered = computed(() => {
    const ACTIONS = [];
    forEach(cloneDeep(rowActions.value), action => {
      if (!action.permission ||
        checkPermissionsSync({ perm: action.permission })) {
        action.permission = undefined;
        if (action.type === "button") {
          const CALLBACK_DEFAULT = action.callback;
          action.callback = arg => CALLBACK_DEFAULT({
            ...arg,
            urlParams: urlParametersLocal.value,
          });
        }
        ACTIONS.push(action);
      }
    });

    return ACTIONS;
  });

  return {
    rowActionsFiltered,
  };
}
